import React from 'react';
import { Box, Typography } from '@mui/material';

export default function EditorStatusBar({
  language,
  line = 1,
  column = 1,
  selectedChars = 0,
  tabSize = 4,
  themeLabel = 'VS Code Dark+',
  wordWrap = false,
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        px: 1.5,
        py: 0.5,
        bgcolor: '#007ACC',
        color: '#FFFFFF',
        fontSize: 12,
        fontFamily: '"Segoe UI", system-ui, sans-serif',
        borderTop: '1px solid #005A9E',
        flexWrap: 'wrap',
      }}
    >
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <Typography component="span" sx={{ fontSize: 12, color: 'inherit' }}>
          {language}
        </Typography>
        <Typography component="span" sx={{ fontSize: 12, color: 'inherit' }}>
          UTF-8
        </Typography>
        <Typography component="span" sx={{ fontSize: 12, color: 'inherit' }}>
          Spaces: {tabSize}
        </Typography>
        <Typography component="span" sx={{ fontSize: 12, color: 'inherit' }}>
          {wordWrap ? 'Wrap' : 'No Wrap'}
        </Typography>
        <Typography component="span" sx={{ fontSize: 12, color: 'inherit' }}>
          {themeLabel}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 2 }}>
        {selectedChars > 0 ? (
          <Typography component="span" sx={{ fontSize: 12, color: 'inherit' }}>
            {selectedChars} selected
          </Typography>
        ) : null}
        <Typography component="span" sx={{ fontSize: 12, color: 'inherit' }}>
          Ln {line}, Col {column}
        </Typography>
      </Box>
    </Box>
  );
}
